import ColdFace from 'assets/image/icons/svg/cold-face.svg'
import EmojiMoney from 'assets/image/icons/svg/emoji-money.svg'
import CloudFace from 'assets/image/icons/svg/face-in-cloud.svg'
import { CONSTS } from 'config/objectConst'
import { wrapExistProxy } from 'shared/utils'

import type { StepHumanState } from './types'

const StepColor = wrapExistProxy(
	{
		Cancelled: CONSTS.COLORS_CAMPAIGNS.cancelled,
		Failed: CONSTS.COLORS_CAMPAIGNS.failed,
		Ignored: CONSTS.COLORS_CAMPAIGNS.ignored,
		InProgress: CONSTS.COLORS_CAMPAIGNS.inProgress,
		InQueue: CONSTS.COLORS_CAMPAIGNS.inQueue,
		NotStarted: CONSTS.COLORS_CAMPAIGNS.inQueue,
		Skipped: CONSTS.COLORS_CAMPAIGNS.skipped,
		Succeed: CONSTS.COLORS_CAMPAIGNS.responded
	} satisfies Record<StepHumanState, string>,
	'Not supported execution state'
)

const QUALIFICATIONS = ['Unqualified', 'Relevant', 'Irrelevant'] as const
type ContactQualification = (typeof QUALIFICATIONS)[number]

const qualificationInfo = {
	Irrelevant: {
		color: CONSTS.COLORS_CAMPAIGNS.ignored,
		emoji: ColdFace,
		label: 'Irrelevant'
	},
	Relevant: {
		color: 'var(--primary)',
		emoji: EmojiMoney,
		label: 'Relevant'
	},
	Unqualified: {
		color: CONSTS.COLORS_CAMPAIGNS.inQueue,
		emoji: CloudFace,
		label: 'Unqualified'
	}
} satisfies Record<
	ContactQualification,
	{ color: string; emoji: string; label: string }
>

export type { ContactQualification }
export { qualificationInfo, QUALIFICATIONS, StepColor }
